import { Card, Col, Divider, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import React from 'react';
import BannersList from './BannersList';

// import { Container } from './styles';

const Banners: React.FC = () => {
  return (
    <Row>
      <Col span={24}>
        <Card>
          <Title level={5}>Banners</Title>
          <Divider />
          <BannersList />
        </Card>
      </Col>
    </Row>
  );
};

export default Banners;
